import Cookies from 'js-cookie'
import config from '../../../config'

export const connectWs = () => {
  const ws = new WebSocket(`wss://${config.apiAdminWsGateway}/ws`)

  ws.onopen = () => {
    ws.send(JSON.stringify({ token: Cookies.get('accessToken'), topic: 'UPDATE-PAYMENT-ACTION' }))
  }

  return ws
}

export const sendMessageWs = (ws, paymentId, action) => {
  ws.send(
    JSON.stringify({
      topic: 'UPDATE-PAYMENT-ACTION',
      payload: JSON.stringify({ id: paymentId, action: action }),
    }),
  )
}
